import React from "react";
import { useLang } from "../i18n";
import { Clock, Users, Mountain, Wine, Languages, MessageCircleHeart } from "lucide-react";

const ICONS = [Clock, Users, Mountain, Wine, Languages, MessageCircleHeart];

export default function TourDetails() {
  const { t } = useLang();
  return (
    <section id="details" data-testid="tour-details" className="py-24 md:py-32 bg-[#F7F1E8]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-[0.28em] text-[#5E7891] mb-5">{t.details.eyebrow}</p>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[#2D3640]">{t.details.title}</h2>
        </div>
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.details.items.map((it, i) => {
            const Icon = ICONS[i] || Clock;
            return (
              <div key={i} data-testid={`detail-${i}`}
                className="group relative p-7 rounded-3xl bg-[#FDFAF3] border border-[#E5D9C0] hover:border-[#8D869B]/60 transition-colors">
                <div className="w-12 h-12 rounded-full bg-[#EDE3DA] flex items-center justify-center mb-5 text-[#5E7891] group-hover:bg-[#C98C97] group-hover:text-[#FDFAF3] transition-colors">
                  <Icon size={20} strokeWidth={1.4} />
                </div>
                <h3 className="font-serif-display text-2xl text-[#2D3640]">{it.t}</h3>
                <p className="mt-2 text-[15px] text-[#4A5A6B] leading-relaxed">{it.d}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
